import IntegrationCallStepResourcePagingResultModel from '../../generated/types/model/resource/IntegrationCallStepResourcePagingResultModel';

export default class IntegrationCallStepResourcePagingResultViewModel extends IntegrationCallStepResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
